// Graded journey. Regenerate with npm run generate:journey.
export const JOURNEY_PUZZLES = [
  {
    "id": "journey-001",
    "difficulty": "easy",
    "size": 4,
    "regions": [
      1,
      0,
      0,
      2,
      1,
      0,
      2,
      2,
      1,
      3,
      3,
      2,
      3,
      3,
      2,
      2
    ],
    "solution": [
      2,
      4,
      11,
      13
    ],
    "givens": [
      2,
      13
    ],
    "variant": 0,
    "level": 1,
    "rating": {
      "tier": 1,
      "score": 24
    }
  },
  {
    "id": "journey-002",
    "difficulty": "easy",
    "size": 4,
    "regions": [
      0,
      0,
      0,
      0,
      1,
      1,
      0,
      2,
      3,
      3,
      0,
      2,
      3,
      3,
      3,
      2
    ],
    "solution": [
      2,
      4,
      11,
      13
    ],
    "givens": [
      2,
      13
    ],
    "variant": 0,
    "level": 2,
    "rating": {
      "tier": 1,
      "score": 24
    }
  },
  {
    "id": "journey-003",
    "difficulty": "easy",
    "size": 4,
    "regions": [
      0,
      0,
      0,
      1,
      0,
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      2,
      3,
      3,
      3
    ],
    "solution": [
      1,
      7,
      8,
      14
    ],
    "givens": [
      7
    ],
    "variant": 0,
    "level": 3,
    "rating": {
      "tier": 1,
      "score": 40
    }
  },
  {
    "id": "journey-004",
    "difficulty": "easy",
    "size": 4,
    "regions": [
      2,
      0,
      0,
      1,
      2,
      0,
      1,
      1,
      2,
      2,
      2,
      3,
      2,
      2,
      3,
      3
    ],
    "solution": [
      1,
      7,
      8,
      14
    ],
    "givens": [
      7
    ],
    "variant": 0,
    "level": 4,
    "rating": {
      "tier": 1,
      "score": 42
    }
  },
  {
    "id": "journey-005",
    "difficulty": "easy",
    "size": 4,
    "regions": [
      2,
      0,
      1,
      1,
      2,
      0,
      0,
      1,
      2,
      2,
      1,
      1,
      3,
      3,
      3,
      3
    ],
    "solution": [
      1,
      7,
      8,
      14
    ],
    "givens": [
      1
    ],
    "variant": 0,
    "level": 5,
    "rating": {
      "tier": 1,
      "score": 42
    }
  },
  {
    "id": "journey-006",
    "difficulty": "easy",
    "size": 4,
    "regions": [
      1,
      0,
      0,
      0,
      1,
      1,
      2,
      2,
      1,
      1,
      2,
      2,
      3,
      3,
      2,
      2
    ],
    "solution": [
      2,
      4,
      11,
      13
    ],
    "givens": [
      2
    ],
    "variant": 0,
    "level": 6,
    "rating": {
      "tier": 1,
      "score": 49
    }
  },
  {
    "id": "journey-007",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      2,
      2,
      1,
      1,
      4,
      4,
      3,
      3,
      3,
      4,
      4,
      4,
      4,
      3
    ],
    "solution": [
      0,
      8,
      11,
      19,
      22
    ],
    "givens": [
      22
    ],
    "variant": 0,
    "level": 7,
    "rating": {
      "tier": 1,
      "score": 61
    }
  },
  {
    "id": "journey-008",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      1,
      0,
      0,
      0,
      0,
      1,
      1,
      3,
      0,
      0,
      1,
      3,
      3,
      4,
      2,
      1,
      3,
      4,
      4,
      4,
      1,
      1,
      4,
      4,
      4
    ],
    "solution": [
      2,
      5,
      14,
      16,
      23
    ],
    "givens": [
      16
    ],
    "variant": 0,
    "level": 8,
    "rating": {
      "tier": 1,
      "score": 66
    }
  },
  {
    "id": "journey-009",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      0,
      0,
      0,
      2,
      2,
      0,
      1,
      1,
      2,
      2,
      3,
      3,
      3,
      2,
      2,
      3,
      3,
      3,
      4,
      4,
      3,
      3,
      4,
      4,
      4
    ],
    "solution": [
      0,
      7,
      14,
      16,
      23
    ],
    "givens": [
      16
    ],
    "variant": 0,
    "level": 9,
    "rating": {
      "tier": 1,
      "score": 72
    }
  },
  {
    "id": "journey-010",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      0,
      0,
      0,
      1,
      1,
      0,
      2,
      0,
      1,
      1,
      3,
      2,
      2,
      2,
      1,
      3,
      3,
      3,
      3,
      4,
      3,
      4,
      4,
      4,
      4
    ],
    "solution": [
      1,
      9,
      12,
      15,
      23
    ],
    "givens": [
      12
    ],
    "variant": 0,
    "level": 10,
    "rating": {
      "tier": 2,
      "score": 72
    }
  },
  {
    "id": "journey-011",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      0,
      0,
      0,
      1,
      2,
      0,
      0,
      3,
      1,
      2,
      0,
      0,
      1,
      1,
      1,
      0,
      1,
      1,
      1,
      1,
      4,
      4,
      4,
      4,
      4
    ],
    "solution": [
      4,
      7,
      10,
      18,
      21
    ],
    "givens": [],
    "variant": 0,
    "level": 11,
    "rating": {
      "tier": 1,
      "score": 143
    }
  },
  {
    "id": "journey-012",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      4,
      0,
      0,
      0,
      0,
      4,
      1,
      0,
      0,
      0,
      4,
      4,
      4,
      0,
      2,
      3,
      3,
      4,
      0,
      2,
      4,
      4,
      4,
      4,
      2
    ],
    "solution": [
      3,
      6,
      14,
      15,
      22
    ],
    "givens": [],
    "variant": 0,
    "level": 12,
    "rating": {
      "tier": 1,
      "score": 148
    }
  },
  {
    "id": "journey-013",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      0,
      0,
      0,
      2,
      2,
      1,
      0,
      3,
      2,
      2,
      1,
      3,
      3,
      2,
      2,
      3,
      3,
      3,
      3,
      2,
      3,
      3,
      4,
      4,
      2
    ],
    "solution": [
      2,
      5,
      14,
      16,
      23
    ],
    "givens": [],
    "variant": 0,
    "level": 13,
    "rating": {
      "tier": 2,
      "score": 127
    }
  },
  {
    "id": "journey-014",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      1,
      1,
      0,
      0,
      0,
      2,
      1,
      1,
      3,
      3,
      2,
      4,
      4,
      3,
      3,
      4,
      4,
      3,
      3,
      3,
      4,
      4,
      4,
      4,
      4
    ],
    "solution": [
      4,
      7,
      10,
      18,
      21
    ],
    "givens": [],
    "variant": 0,
    "level": 14,
    "rating": {
      "tier": 2,
      "score": 134
    }
  },
  {
    "id": "journey-015",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      1,
      1,
      2,
      2,
      0,
      3,
      1,
      2,
      2,
      0,
      3,
      4,
      4,
      2,
      2,
      3,
      4,
      2,
      2,
      2,
      3,
      4,
      4,
      4,
      2
    ],
    "solution": [
      4,
      6,
      13,
      15,
      22
    ],
    "givens": [],
    "variant": 0,
    "level": 15,
    "rating": {
      "tier": 2,
      "score": 135
    }
  },
  {
    "id": "journey-016",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      1,
      1,
      1,
      1,
      0,
      2,
      2,
      1,
      1,
      1,
      2,
      4,
      1,
      1,
      3,
      2,
      4,
      4,
      3,
      3,
      4,
      4,
      4,
      3,
      3
    ],
    "solution": [
      4,
      7,
      10,
      18,
      21
    ],
    "givens": [],
    "variant": 0,
    "level": 16,
    "rating": {
      "tier": 2,
      "score": 142
    }
  },
  {
    "id": "journey-017",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      0,
      1,
      2,
      2,
      2,
      0,
      1,
      1,
      2,
      2,
      0,
      3,
      1,
      2,
      2,
      3,
      3,
      4,
      4,
      2,
      3,
      4,
      4,
      4,
      4
    ],
    "solution": [
      0,
      7,
      14,
      16,
      23
    ],
    "givens": [],
    "variant": 0,
    "level": 17,
    "rating": {
      "tier": 2,
      "score": 146
    }
  },
  {
    "id": "journey-018",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      1,
      1,
      1,
      0,
      2,
      2,
      3,
      3,
      0,
      2,
      4,
      4,
      3,
      0,
      4,
      4,
      3,
      3
    ],
    "solution": [
      0,
      8,
      11,
      19,
      22
    ],
    "givens": [],
    "variant": 0,
    "level": 18,
    "rating": {
      "tier": 2,
      "score": 146
    }
  },
  {
    "id": "journey-019",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      2,
      1,
      1,
      0,
      2,
      2,
      2,
      2,
      2,
      2,
      4,
      3,
      3,
      2,
      4,
      4,
      3,
      3
    ],
    "solution": [
      0,
      8,
      11,
      19,
      22
    ],
    "givens": [],
    "variant": 0,
    "level": 19,
    "rating": {
      "tier": 2,
      "score": 148
    }
  },
  {
    "id": "journey-020",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      1,
      1,
      1,
      0,
      0,
      1,
      1,
      1,
      2,
      0,
      1,
      1,
      4,
      2,
      0,
      3,
      4,
      4,
      2,
      0,
      3,
      3,
      4,
      4,
      0
    ],
    "solution": [
      4,
      6,
      13,
      15,
      22
    ],
    "givens": [],
    "variant": 0,
    "level": 20,
    "rating": {
      "tier": 2,
      "score": 153
    }
  },
  {
    "id": "journey-021",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      0,
      0,
      0,
      0,
      0,
      2,
      1,
      1,
      1,
      0,
      2,
      2,
      0,
      0,
      0,
      4,
      4,
      3,
      3,
      3,
      4,
      4,
      3,
      3,
      3
    ],
    "solution": [
      4,
      7,
      10,
      18,
      21
    ],
    "givens": [],
    "variant": 0,
    "level": 21,
    "rating": {
      "tier": 2,
      "score": 153
    }
  },
  {
    "id": "journey-022",
    "difficulty": "easy",
    "size": 5,
    "regions": [
      1,
      2,
      2,
      0,
      0,
      1,
      2,
      2,
      2,
      2,
      4,
      4,
      2,
      3,
      3,
      4,
      4,
      4,
      3,
      3,
      4,
      4,
      4,
      3,
      3
    ],
    "solution": [
      3,
      5,
      12,
      19,
      21
    ],
    "givens": [],
    "variant": 0,
    "level": 22,
    "rating": {
      "tier": 2,
      "score": 155
    }
  },
  {
    "id": "journey-023",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      1,
      1,
      1,
      0,
      0,
      0,
      1,
      1,
      1,
      0,
      0,
      0,
      1,
      1,
      1,
      2,
      2,
      0,
      1,
      3,
      3,
      3,
      0,
      0,
      4,
      3,
      3,
      3,
      3,
      3,
      4,
      4,
      5,
      5,
      3,
      3
    ],
    "solution": [
      5,
      7,
      16,
      20,
      24,
      33
    ],
    "givens": [
      20
    ],
    "variant": 0,
    "level": 23,
    "rating": {
      "tier": 1,
      "score": 76
    }
  },
  {
    "id": "journey-024",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      0,
      0,
      2,
      2,
      1,
      1,
      2,
      2,
      2,
      2,
      1,
      1,
      4,
      4,
      2,
      1,
      1,
      1,
      4,
      2,
      2,
      3,
      3,
      1,
      4,
      5,
      5,
      5,
      1,
      1,
      4,
      5,
      5,
      5,
      5,
      5
    ],
    "solution": [
      1,
      11,
      14,
      22,
      24,
      33
    ],
    "givens": [
      14
    ],
    "variant": 0,
    "level": 24,
    "rating": {
      "tier": 1,
      "score": 117
    }
  },
  {
    "id": "journey-025",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      5,
      0,
      0,
      0,
      0,
      1,
      5,
      3,
      0,
      0,
      0,
      1,
      5,
      3,
      2,
      2,
      2,
      1,
      5,
      3,
      3,
      3,
      4,
      1,
      5,
      3,
      3,
      3,
      4,
      4,
      5,
      5,
      5,
      5,
      5,
      4
    ],
    "solution": [
      2,
      11,
      15,
      19,
      28,
      30
    ],
    "givens": [
      15
    ],
    "variant": 0,
    "level": 25,
    "rating": {
      "tier": 2,
      "score": 108
    }
  },
  {
    "id": "journey-026",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      3,
      2,
      2,
      2,
      1,
      1,
      3,
      3,
      3,
      5,
      1,
      1,
      3,
      4,
      4,
      5,
      5,
      3,
      3,
      3,
      5,
      5,
      5
    ],
    "solution": [
      2,
      6,
      16,
      19,
      27,
      35
    ],
    "givens": [
      16
    ],
    "variant": 0,
    "level": 26,
    "rating": {
      "tier": 2,
      "score": 113
    }
  },
  {
    "id": "journey-027",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      1,
      1,
      1,
      1,
      1,
      0,
      1,
      1,
      1,
      0,
      0,
      0,
      4,
      1,
      1,
      2,
      2,
      0,
      4,
      4,
      3,
      2,
      2,
      2,
      4,
      4,
      4,
      5,
      5,
      5,
      4,
      4,
      5,
      5,
      5,
      5
    ],
    "solution": [
      5,
      7,
      16,
      20,
      24,
      33
    ],
    "givens": [],
    "variant": 0,
    "level": 27,
    "rating": {
      "tier": 1,
      "score": 209
    }
  },
  {
    "id": "journey-028",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      2,
      1,
      1,
      1,
      0,
      2,
      2,
      2,
      1,
      1,
      0,
      2,
      2,
      3,
      3,
      3,
      3,
      2,
      2,
      3,
      5,
      4,
      3,
      5,
      5,
      5,
      5,
      4,
      4
    ],
    "solution": [
      5,
      9,
      12,
      20,
      28,
      31
    ],
    "givens": [],
    "variant": 0,
    "level": 28,
    "rating": {
      "tier": 2,
      "score": 162
    }
  },
  {
    "id": "journey-029",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      1,
      1,
      1,
      0,
      0,
      0,
      2,
      3,
      1,
      1,
      1,
      0,
      2,
      3,
      3,
      1,
      1,
      0,
      2,
      3,
      3,
      1,
      1,
      0,
      3,
      3,
      3,
      3,
      4,
      0,
      5,
      5,
      4,
      4,
      4,
      4
    ],
    "solution": [
      5,
      9,
      12,
      20,
      28,
      31
    ],
    "givens": [],
    "variant": 0,
    "level": 29,
    "rating": {
      "tier": 2,
      "score": 194
    }
  },
  {
    "id": "journey-030",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      1,
      1,
      1,
      1,
      2,
      0,
      1,
      1,
      1,
      1,
      2,
      0,
      4,
      1,
      3,
      2,
      2,
      2,
      4,
      4,
      3,
      2,
      5,
      5,
      4,
      4,
      5,
      5,
      5,
      5,
      4,
      4,
      4,
      5,
      5,
      5
    ],
    "solution": [
      5,
      7,
      16,
      20,
      24,
      33
    ],
    "givens": [],
    "variant": 0,
    "level": 30,
    "rating": {
      "tier": 2,
      "score": 207
    }
  },
  {
    "id": "journey-031",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      3,
      0,
      0,
      0,
      0,
      1,
      3,
      0,
      0,
      1,
      1,
      1,
      3,
      2,
      2,
      4,
      1,
      1,
      3,
      5,
      4,
      4,
      4,
      4,
      3,
      5,
      5,
      4,
      4,
      4,
      5,
      5,
      4,
      4,
      4,
      4
    ],
    "solution": [
      3,
      11,
      14,
      18,
      28,
      31
    ],
    "givens": [],
    "variant": 0,
    "level": 31,
    "rating": {
      "tier": 2,
      "score": 213
    }
  },
  {
    "id": "journey-032",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      0,
      0,
      0,
      2,
      2,
      2,
      0,
      1,
      1,
      2,
      2,
      2,
      0,
      0,
      0,
      2,
      2,
      2,
      3,
      3,
      0,
      4,
      4,
      4,
      3,
      5,
      5,
      4,
      4,
      4,
      5,
      5,
      5,
      5,
      4,
      4
    ],
    "solution": [
      0,
      8,
      16,
      19,
      29,
      33
    ],
    "givens": [],
    "variant": 0,
    "level": 32,
    "rating": {
      "tier": 2,
      "score": 223
    }
  },
  {
    "id": "journey-033",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      4,
      1,
      1,
      1,
      0,
      0,
      4,
      1,
      1,
      1,
      2,
      0,
      4,
      1,
      2,
      2,
      2,
      2,
      4,
      1,
      2,
      2,
      5,
      3,
      4,
      4,
      4,
      5,
      5,
      5,
      4,
      5,
      5,
      5,
      5,
      5
    ],
    "solution": [
      4,
      7,
      15,
      23,
      24,
      32
    ],
    "givens": [],
    "variant": 0,
    "level": 33,
    "rating": {
      "tier": 2,
      "score": 226
    }
  },
  {
    "id": "journey-034",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      0,
      0,
      0,
      0,
      1,
      1,
      0,
      2,
      0,
      0,
      0,
      1,
      2,
      2,
      2,
      3,
      3,
      3,
      2,
      2,
      3,
      3,
      5,
      5,
      4,
      2,
      3,
      3,
      5,
      5,
      2,
      2,
      5,
      5,
      5,
      5
    ],
    "solution": [
      2,
      11,
      13,
      21,
      24,
      34
    ],
    "givens": [],
    "variant": 0,
    "level": 34,
    "rating": {
      "tier": 2,
      "score": 226
    }
  },
  {
    "id": "journey-035",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      1,
      0,
      0,
      0,
      2,
      2,
      1,
      3,
      0,
      0,
      2,
      2,
      3,
      3,
      3,
      2,
      2,
      4,
      5,
      3,
      3,
      4,
      4,
      4,
      5,
      5,
      3,
      4,
      4,
      4,
      5,
      5,
      3,
      4,
      4,
      4
    ],
    "solution": [
      3,
      6,
      16,
      20,
      29,
      31
    ],
    "givens": [],
    "variant": 0,
    "level": 35,
    "rating": {
      "tier": 2,
      "score": 233
    }
  },
  {
    "id": "journey-036",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      0,
      0,
      0,
      0,
      1,
      1,
      3,
      3,
      2,
      0,
      0,
      1,
      3,
      2,
      2,
      0,
      1,
      1,
      3,
      3,
      3,
      4,
      4,
      1,
      5,
      3,
      5,
      4,
      4,
      4,
      5,
      5,
      5,
      4,
      4,
      4
    ],
    "solution": [
      3,
      11,
      14,
      18,
      28,
      31
    ],
    "givens": [],
    "variant": 0,
    "level": 36,
    "rating": {
      "tier": 3,
      "score": 217
    }
  },
  {
    "id": "journey-037",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      0,
      0,
      0,
      0,
      1,
      1,
      0,
      3,
      2,
      0,
      1,
      1,
      0,
      3,
      2,
      0,
      1,
      1,
      3,
      3,
      4,
      4,
      4,
      1,
      3,
      3,
      4,
      4,
      4,
      4,
      5,
      5,
      5,
      4,
      4,
      4
    ],
    "solution": [
      3,
      11,
      14,
      18,
      28,
      31
    ],
    "givens": [],
    "variant": 0,
    "level": 37,
    "rating": {
      "tier": 3,
      "score": 263
    }
  },
  {
    "id": "journey-038",
    "difficulty": "medium",
    "size": 6,
    "regions": [
      1,
      1,
      1,
      1,
      0,
      0,
      2,
      2,
      1,
      1,
      3,
      3,
      2,
      2,
      1,
      3,
      3,
      3,
      2,
      2,
      2,
      3,
      3,
      3,
      5,
      2,
      5,
      3,
      4,
      4,
      5,
      5,
      5,
      3,
      4,
      4
    ],
    "solution": [
      4,
      8,
      12,
      21,
      29,
      31
    ],
    "givens": [],
    "variant": 0,
    "level": 38,
    "rating": {
      "tier": 3,
      "score": 269
    }
  },
  {
    "id": "journey-039",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      0,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      3,
      3,
      1,
      1,
      1,
      3,
      3,
      3,
      3,
      4,
      2,
      2,
      3,
      3,
      3,
      4,
      4,
      2,
      2,
      6,
      3,
      3,
      4,
      4,
      4,
      4,
      6,
      5,
      5,
      5,
      5,
      4,
      4,
      6,
      6,
      5,
      5,
      5,
      4,
      4
    ],
    "solution": [
      0,
      11,
      20,
      23,
      33,
      38,
      43
    ],
    "givens": [
      33
    ],
    "variant": 0,
    "level": 39,
    "rating": {
      "tier": 1,
      "score": 138
    }
  },
  {
    "id": "journey-040",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      2,
      2,
      2,
      1,
      1,
      0,
      0,
      2,
      2,
      2,
      2,
      1,
      1,
      1,
      2,
      2,
      2,
      2,
      3,
      3,
      3,
      2,
      4,
      3,
      3,
      3,
      5,
      3,
      2,
      4,
      6,
      6,
      6,
      5,
      3,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      6,
      6,
      6,
      6,
      6,
      6,
      5
    ],
    "solution": [
      6,
      11,
      14,
      24,
      29,
      40,
      44
    ],
    "givens": [
      44
    ],
    "variant": 0,
    "level": 40,
    "rating": {
      "tier": 2,
      "score": 147
    }
  },
  {
    "id": "journey-041",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      0,
      0,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      3,
      3,
      3,
      1,
      2,
      2,
      1,
      3,
      3,
      3,
      1,
      3,
      3,
      3,
      3,
      4,
      4,
      5,
      5,
      3,
      3,
      4,
      4,
      4,
      5,
      5,
      5,
      6,
      4,
      4,
      4,
      5,
      5,
      5,
      6,
      6,
      6,
      6
    ],
    "solution": [
      0,
      10,
      15,
      25,
      34,
      37,
      47
    ],
    "givens": [
      25
    ],
    "variant": 0,
    "level": 41,
    "rating": {
      "tier": 2,
      "score": 159
    }
  },
  {
    "id": "journey-042",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      0,
      0,
      0,
      1,
      1,
      1,
      1,
      0,
      1,
      1,
      1,
      2,
      2,
      1,
      0,
      3,
      1,
      2,
      2,
      2,
      2,
      0,
      3,
      3,
      2,
      2,
      4,
      6,
      0,
      0,
      3,
      6,
      6,
      4,
      6,
      0,
      0,
      3,
      5,
      6,
      6,
      6,
      0,
      3,
      3,
      3,
      6,
      6,
      6
    ],
    "solution": [
      0,
      9,
      18,
      22,
      33,
      38,
      48
    ],
    "givens": [
      9
    ],
    "variant": 0,
    "level": 42,
    "rating": {
      "tier": 2,
      "score": 168
    }
  },
  {
    "id": "journey-043",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      0,
      0,
      0,
      1,
      1,
      1,
      1,
      0,
      0,
      0,
      1,
      1,
      1,
      1,
      2,
      2,
      0,
      1,
      1,
      1,
      1,
      2,
      3,
      3,
      1,
      1,
      5,
      5,
      2,
      6,
      6,
      4,
      4,
      4,
      5,
      6,
      6,
      4,
      4,
      6,
      5,
      5,
      6,
      6,
      6,
      6,
      6,
      5,
      5
    ],
    "solution": [
      1,
      12,
      14,
      23,
      32,
      41,
      45
    ],
    "givens": [],
    "variant": 0,
    "level": 43,
    "rating": {
      "tier": 2,
      "score": 275
    }
  },
  {
    "id": "journey-044",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      1,
      0,
      1,
      2,
      0,
      0,
      1,
      1,
      1,
      1,
      2,
      2,
      1,
      1,
      3,
      3,
      3,
      2,
      2,
      1,
      3,
      3,
      3,
      4,
      5,
      5,
      5,
      5,
      3,
      6,
      4,
      3,
      3,
      3,
      3,
      3,
      6,
      6
    ],
    "solution": [
      1,
      10,
      14,
      25,
      34,
      37,
      47
    ],
    "givens": [],
    "variant": 0,
    "level": 44,
    "rating": {
      "tier": 2,
      "score": 278
    }
  },
  {
    "id": "journey-045",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      2,
      2,
      2,
      2,
      1,
      1,
      0,
      2,
      2,
      2,
      3,
      1,
      1,
      0,
      2,
      4,
      4,
      3,
      1,
      1,
      0,
      0,
      4,
      3,
      3,
      1,
      5,
      0,
      0,
      4,
      3,
      3,
      1,
      5,
      4,
      4,
      4,
      6,
      6,
      6,
      5
    ],
    "solution": [
      0,
      12,
      15,
      25,
      30,
      41,
      45
    ],
    "givens": [],
    "variant": 0,
    "level": 45,
    "rating": {
      "tier": 2,
      "score": 297
    }
  },
  {
    "id": "journey-046",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      1,
      2,
      2,
      0,
      0,
      0,
      0,
      1,
      1,
      2,
      2,
      0,
      0,
      0,
      1,
      2,
      2,
      0,
      0,
      0,
      0,
      1,
      1,
      2,
      2,
      3,
      3,
      3,
      5,
      1,
      5,
      2,
      3,
      4,
      4,
      5,
      5,
      5,
      5,
      5,
      5,
      4,
      5,
      5,
      5,
      5,
      5,
      6,
      6
    ],
    "solution": [
      3,
      7,
      16,
      25,
      34,
      36,
      47
    ],
    "givens": [],
    "variant": 0,
    "level": 46,
    "rating": {
      "tier": 2,
      "score": 302
    }
  },
  {
    "id": "journey-047",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      1,
      1,
      1,
      0,
      0,
      0,
      0,
      1,
      1,
      1,
      1,
      1,
      0,
      0,
      1,
      1,
      1,
      3,
      2,
      0,
      0,
      1,
      3,
      3,
      3,
      4,
      0,
      0,
      3,
      3,
      3,
      4,
      4,
      4,
      5,
      3,
      3,
      3,
      4,
      6,
      4,
      5,
      3,
      3,
      6,
      6,
      6,
      6,
      5
    ],
    "solution": [
      5,
      7,
      18,
      22,
      31,
      41,
      44
    ],
    "givens": [],
    "variant": 0,
    "level": 47,
    "rating": {
      "tier": 2,
      "score": 310
    }
  },
  {
    "id": "journey-048",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      1,
      1,
      1,
      0,
      0,
      0,
      0,
      1,
      1,
      1,
      1,
      2,
      2,
      0,
      1,
      1,
      1,
      2,
      2,
      2,
      0,
      3,
      3,
      3,
      2,
      2,
      2,
      2,
      4,
      4,
      3,
      3,
      3,
      2,
      2,
      3,
      3,
      3,
      5,
      5,
      5,
      5,
      6,
      6,
      6,
      5,
      5,
      5,
      5
    ],
    "solution": [
      6,
      10,
      19,
      23,
      28,
      39,
      43
    ],
    "givens": [],
    "variant": 0,
    "level": 48,
    "rating": {
      "tier": 2,
      "score": 322
    }
  },
  {
    "id": "journey-049",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      0,
      0,
      2,
      1,
      1,
      1,
      1,
      2,
      2,
      2,
      3,
      3,
      1,
      5,
      2,
      3,
      3,
      3,
      4,
      5,
      5,
      3,
      3,
      3,
      4,
      4,
      5,
      5,
      3,
      3,
      6,
      4,
      4,
      5,
      5,
      3,
      6,
      6,
      4,
      6,
      5,
      5,
      6,
      6,
      6,
      6,
      6,
      6,
      5
    ],
    "solution": [
      1,
      12,
      14,
      23,
      32,
      41,
      45
    ],
    "givens": [],
    "variant": 0,
    "level": 49,
    "rating": {
      "tier": 2,
      "score": 334
    }
  },
  {
    "id": "journey-050",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      1,
      1,
      0,
      0,
      0,
      0,
      1,
      1,
      1,
      3,
      3,
      3,
      2,
      1,
      5,
      1,
      3,
      3,
      3,
      4,
      5,
      5,
      1,
      3,
      4,
      4,
      4,
      5,
      5,
      5,
      3,
      6,
      4,
      4,
      5,
      5,
      5,
      5,
      6,
      6,
      6
    ],
    "solution": [
      2,
      7,
      20,
      24,
      33,
      36,
      46
    ],
    "givens": [],
    "variant": 0,
    "level": 50,
    "rating": {
      "tier": 2,
      "score": 337
    }
  },
  {
    "id": "journey-051",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      1,
      0,
      0,
      2,
      2,
      2,
      3,
      1,
      1,
      0,
      2,
      2,
      2,
      3,
      4,
      4,
      2,
      2,
      3,
      3,
      3,
      4,
      4,
      2,
      3,
      3,
      3,
      3,
      4,
      4,
      5,
      5,
      3,
      5,
      3,
      4,
      4,
      4,
      5,
      5,
      5,
      5,
      4,
      4,
      4,
      6,
      6,
      6,
      5
    ],
    "solution": [
      2,
      7,
      17,
      26,
      29,
      41,
      46
    ],
    "givens": [],
    "variant": 0,
    "level": 51,
    "rating": {
      "tier": 3,
      "score": 350
    }
  },
  {
    "id": "journey-052",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      0,
      0,
      1,
      1,
      1,
      3,
      3,
      1,
      1,
      1,
      1,
      2,
      3,
      3,
      1,
      1,
      2,
      2,
      2,
      3,
      3,
      1,
      5,
      4,
      2,
      3,
      3,
      3,
      5,
      5,
      4,
      4,
      3,
      3,
      3,
      5,
      5,
      4,
      6,
      6,
      3,
      6,
      5,
      5,
      4,
      4,
      6,
      6,
      6
    ],
    "solution": [
      0,
      9,
      18,
      27,
      31,
      36,
      47
    ],
    "givens": [],
    "variant": 0,
    "level": 52,
    "rating": {
      "tier": 3,
      "score": 389
    }
  },
  {
    "id": "journey-053",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      3,
      1,
      1,
      0,
      2,
      2,
      4,
      3,
      1,
      1,
      0,
      2,
      4,
      4,
      3,
      1,
      3,
      0,
      2,
      2,
      4,
      3,
      3,
      3,
      3,
      2,
      4,
      4,
      5,
      3,
      6,
      3,
      6,
      4,
      6,
      5,
      5,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      6,
      6,
      6,
      6,
      6
    ],
    "solution": [
      3,
      8,
      18,
      23,
      33,
      35,
      48
    ],
    "givens": [],
    "variant": 0,
    "level": 53,
    "rating": {
      "tier": 3,
      "score": 403
    }
  },
  {
    "id": "journey-054",
    "difficulty": "hard",
    "size": 7,
    "regions": [
      0,
      0,
      0,
      1,
      1,
      1,
      1,
      0,
      0,
      2,
      5,
      1,
      1,
      1,
      2,
      2,
      2,
      5,
      1,
      1,
      1,
      2,
      2,
      3,
      5,
      5,
      5,
      5,
      2,
      3,
      3,
      4,
      4,
      5,
      5,
      6,
      6,
      6,
      4,
      4,
      5,
      5,
      6,
      6,
      6,
      6,
      6,
      5,
      5
    ],
    "solution": [
      1,
      12,
      14,
      23,
      32,
      41,
      45
    ],
    "givens": [],
    "variant": 0,
    "level": 54,
    "rating": {
      "tier": 3,
      "score": 459
    }
  }
];
